import { defineStore } from 'pinia'

export const useArticleStore = defineStore('article', {
  state: () => ({
    articleId: null,
    language: 'vi',
    mainKeyword: '',
    subKeywords: '',
    semanticKeywords: '',
    outline: '',
    title: '',
    description: '',
    cta: '',
    content: '',
    internalLinks: '',
    focusKeyword: '',
    images: '',
    slug: '',
    selectedSiteId: null,
    selectedCategoryIds: [],
  }),

  actions: {
    setArticleId(id) {
      this.articleId = id
    },
    reset() {
      this.articleId = null
      this.language = 'vi'
      this.mainKeyword = ''
      this.subKeywords = ''
      this.semanticKeywords = ''
      this.outline = ''
      this.title = ''
      this.description = ''
      this.cta = ''
      this.content = ''
      this.internalLinks = ''
      this.focusKeyword = ''
      this.images = ''
      this.slug = ''
      this.selectedSiteId = null
      this.selectedCategoryIds = []
    }
  }
})
